import { removeAcento } from "./strings";
import { filtrosRetrabalho } from "../constants/filterRetrabalho";
import { messageError } from "./message";

import { clearUser } from "./clearUser";

export function catchErro(navigate, err, isClearUser = false, message = "Erro ao buscar tarefas.") {
  let customMessage = ""

  if (err?.response?.data?.Erro) {
    customMessage = err.response.data.Erro
  } else {
    customMessage = err.response.data.message
  }

  messageError(customMessage || message);

  if (
    isClearUser &&
    [400, 401, 403, 404, 500].includes(err.request.status)
  ) {
    clearUser(navigate);
  }
}

export function verifyToken(token, navigate) {
  if (!token) {
    clearUser(navigate);
    return false;
  }
  try {
    const decoded = JSON.parse(atob(token.split(".")[1]));
    const expiresStr = decoded.expires;
    if (!expiresStr) {
      clearUser(navigate);
      return false;
    }
    const expiresDate = new Date(expiresStr + " UTC");
    const expiresTimestamp = expiresDate.getTime();
    const nowTimestamp = Date.now();
    if (expiresTimestamp < nowTimestamp) {
      clearUser(navigate);

      return false;
    }
    return true;
  } catch (e) {
    clearUser(navigate);
    return false;
  }
}

export const retrabalhoLogic = (data, setLoading) => {
  const fraseTratada = removeAcento(data["ds_apontamento"].toLowerCase());

  const isInvalid = filtrosRetrabalho.some((filtro) => {
    const treatedFiltro = removeAcento(filtro);

    if (fraseTratada.includes(treatedFiltro)) {
      messageError(`Não usar a palavra "${filtro}" se não for retrabalho.`);

      setLoading && setLoading(false);

      return true;
    }

    return false;
  });

  return isInvalid;
};

export const validacaoPBI = (data) => {
  if (data["ao_solicita_pbi"] === "S") {
    if (!data["pbi_key"]) {
      messageError("PBI é obrigatória");
      return false;
    } else if (data["pbi_key"].length > 20) {
      messageError("PBI pode ter no máximo 20 caracteres.");
      return false;
    }
  }

  return true;
};

export const numberInHours = (num) => {
  const hours = Math.floor(num);
  const minutes = Math.round((num - hours) * 60);

  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}`;
};
